import axios from 'axios';
import { cloneDeep } from 'lodash'
import publisher from './condition/publisher'
import getThrough from './condition/get_through'

const initialState = {
  firstSelectedSearchType: true,    // 初めて検索タイプを変えたか
  savePrintName: '',                    //プリント名
  selectedSearchType: 1,           //検索タイプ（１：教科書モード、２：ゲットスルーモード）
  selectedTextbook: 1,              //準拠教科書(初期値：１)
  selectedGrade: 1,                 //学年(初期値：１)
  selectedCategory: 1,              //種別（１:見出し、２：応用、３：テーマ別）
  checkedArr: {                     //チェックボックスと複数選択可なラジオボタン群
    reibun: [],                       //例文問題（１：適語補充、２：全文）
    katsuyo: [],                      //活用形（１：過去形、２：過去分詞、３：比較、４：最上級、５：複数形）
    hanigo: [],                       //反意語（1:反意語含む）
    hinshi: [],                       //品詞の限定(１：名詞、２：動詞、３：形容詞)
    target: [1],                       //出題対象(１：単語、２：連語、３：既習語)
    eiwa: [],                        //英和・和英選択（1:英和、２：和英）
  },
  katsuyoAllCheck: false,             //活用問題の「すべてを選択」フラグ
  selectedQuestionRangeType: 1,       //範囲種別（１：ページから、２：単元から、３：見出しから）
  selectedQuestionRangePage: { //範囲種別 １：ページ の場合
    tango:[
      {
        start: '',        //開始（単語）
        end: '',          //終了（単語）
      }
    ],
    rengo: [
      {
        start: '',        //開始（連語）
        end: '',          //終了（連語）
      }
    ],
  },
  selectedQuestionRangeTangen: [],      //範囲種別 ２：単元 の場合(親単元複数選択可能)
    /* この形で格納(初期値はマスタで取得し、整形)
    {
      text: '単元1',
      value: 1,
      isShow: false,
      isAllSelected: false,
      children: [
        {text: '単元1-1', value: '1-1', checked: false},
        {text: '単元1-2', value: '1-2', checked: false},
      ]
    },
    */
  selectedQuestionRangeMidashi: { //範囲種別 ３：見出し の場合
    tango:[
      {
        start: '',        //開始（単語）
        end: '',          //終了（単語）
      }
    ],
    rengo: [
      {
        start: '',        //開始（連語）
        end: '',          //終了（連語）
      }
    ],
  },

  selectedQuestionRangeTheme: [],      //テーマ別場合、テーマを選択する(親テーマ複数選択可能)
    /* この形で格納
      {
        text: 'テーマ1',
        value: 1,
        isShow: false,
        isAllSelected: false,
        children: [
          {text: 'テーマ1-1', value: '1-1'},
          {text: 'テーマ1-2', value: '1-2'},
          {text: 'テーマ1-3', value: '1-3'},
        ]
      },
    */
  questionNumAreas: {
    headword: {
      pattern: 1,
      setsumonTitle: '見出し(単語)',
      setsumonLabel: '設問数',
      setsumonModelName: 'other',
      maxAvailableWordNum: null,
      value: null,
      displayFlg: false
    },
    compound: {
      pattern: 2,
      setsumonTitle: '見出し(連語)',
      setsumonLabel: '設問数',
      setsumonModelName: 'other',
      maxAvailableWordNum: null,
      value: null,
      displayFlg: false
    },
    headwordInSentence: {
      pattern: 3,
      setsumonTitle: '例文(単語)',
      setsumonLabel: '設問数',
      setsumonModelName: 'other',
      maxAvailableWordNum: null,
      value: null,
      displayFlg: false
    },
    compoundInSentence: {
      pattern: 4,
      setsumonTitle: '例文(連語)',
      setsumonLabel: '設問数',
      setsumonModelName: 'other',
      maxAvailableWordNum: null,
      value: null,
      displayFlg: false
    },
    inflectional: {
      pattern: 5,
      setsumonTitle: '活用語',
      setsumonLabel: '設問数',
      setsumonModelName: 'other',
      maxAvailableWordNum: null,
      value: null,
      displayFlg: false
    },
    headwordOpposite: {
      pattern: 6,
      setsumonTitle: '反意語(単語)',
      setsumonLabel: '設問数',
      setsumonModelName: 'hani',
      maxAvailableWordNum: null,
      value: null,
      displayFlg: false
    },
    compoundOpposite: {
      pattern: 7,
      setsumonTitle: '反意語(連語)',
      setsumonLabel: '設問数',
      setsumonModelName: 'hani',
      maxAvailableWordNum: null,
      value: null,
      displayFlg: false
    }
  },                                     //設問数入力欄
  selectedQuestionSortType: 1,           //ソート（1：ページ順(見出し順)、2：ランダム）
  selectedQuestionDescription: 1,        //解説（１：あり、２：なし）
  savePrintMode: false,                  //問題作成からの遷移か保存問題からの遷移か判定
  searchedFlg: false,                    //出題可能語数検索フラグ
  allCheckFlg: false,                    //指定範囲のすべてを出題するフラグ
  printTitle: undefined,                        //プリント名
  printData: {},                         //作成プリントデータ
  conditionDetails: {},                  //抽出条件詳細（保存API用）
  selectedLogoFlg: 1,                    // ロゴ表示フラグ（初期値：true）

  questionNumAreasDisplayCheck: function() {
    // 教科書が押されたら反意語は非表示
    if (this.selectedSearchType === 1) {
      this.questionNumAreas.headwordOpposite.displayFlg = false
      this.questionNumAreas.compoundOpposite.displayFlg = false
    }
    if(this.selectedCategory === 1 || this.selectedCategory === 3) {
      //応用問題用の表示欄を非表示する
      this.questionNumAreas.headwordInSentence.displayFlg = false
      this.questionNumAreas.compoundInSentence.displayFlg = false
      this.questionNumAreas.inflectional.displayFlg = false
      this.questionNumAreas.headwordOpposite.displayFlg = false
      this.questionNumAreas.compoundOpposite.displayFlg = false

      //1,見出し問題×単語
      if(this.checkedArr['target'].includes(1)) this.questionNumAreas.headword.displayFlg = true
      else this.questionNumAreas.headword.displayFlg = false
      //２,見出し問題×連語
      if(this.checkedArr['target'].includes(2)) this.questionNumAreas.compound.displayFlg = true
      else this.questionNumAreas.compound.displayFlg = false
    }
    if(this.selectedCategory === 2) {
      //見出し語問題用の表示欄を非表示する
      this.questionNumAreas.headword.displayFlg = false
      this.questionNumAreas.compound.displayFlg = false

      //3,応用問題（例文）×単語
      if(this.checkedArr['reibun'].length > 0 && this.checkedArr['target'].includes(1)) this.questionNumAreas.headwordInSentence.displayFlg = true
      else this.questionNumAreas.headwordInSentence.displayFlg = false
      //4,応用問題（例文）×連語
      if(this.checkedArr['reibun'].length > 0 && this.checkedArr['target'].includes(2)) this.questionNumAreas.compoundInSentence.displayFlg = true
      else this.questionNumAreas.compoundInSentence.displayFlg = false
      //5,応用問題（活用語）
      if(this.checkedArr['katsuyo'].length > 0) this.questionNumAreas.inflectional.displayFlg = true
      else this.questionNumAreas.inflectional.displayFlg = false
      //6,応用問題（反意語）×単語
      if(this.selectedSearchType === 2 && this.checkedArr['hanigo'].length > 0 && this.checkedArr['target'].includes(1)) this.questionNumAreas.headwordOpposite.displayFlg = true
      else this.questionNumAreas.headwordOpposite.displayFlg = false
      //7,応用問題（反意語）×連語
      if(this.selectedSearchType === 2 && this.checkedArr['hanigo'].length > 0 && this.checkedArr['target'].includes(2)) this.questionNumAreas.compoundOpposite.displayFlg = true
      else this.questionNumAreas.compoundOpposite.displayFlg = false

      if(this.checkedArr['hanigo'].length === 0) {
        this.questionNumAreas.headwordOpposite.displayFlg = false
        this.questionNumAreas.compoundOpposite.displayFlg = false
      }
    }
    //非表示にする際入力値をリセットする
    Object.entries(this.questionNumAreas)
      .map(a => a[1])
      .forEach(x=>{
        if(!x.displayFlg) x.value = null
      })

  }
}

export default {
  namespaced: true,
  state: cloneDeep(initialState),

  getters: {
    // Flag
    isCategoryMidashi: state => {
      return state.selectedCategory === 1
    },
    isCategoryAdvanced: state => {
      return state.selectedCategory === 2
    },
    isCategoryTheme: state => {
      return state.selectedCategory === 3
    },
    selectedRangeTypeIsPage: state => {
      return state.selectedQuestionRangeType === 1
    },
    selectedRangeTypeIsUnit: state => {
      return state.selectedQuestionRangeType === 2
    },
    selectedRangeTypeIsMidashiId: state => {
      return state.selectedQuestionRangeType === 3
    },
    // 単語ページ範囲
    isShowPagesTango: (state) => {
      // 教科書の場合は表示
      if (state.selectedSearchType === 1) return true
      // ゲットスルー
      else {
        return state.questionNumAreas.headword.displayFlg || state.questionNumAreas.headwordInSentence.displayFlg || state.questionNumAreas.headwordOpposite.displayFlg || state.questionNumAreas.inflectional.displayFlg
      }
    },
    // 連語ページ範囲
    isShowPagesRengo: state => {
      return ( state.questionNumAreas.compound.displayFlg || state.questionNumAreas.compoundInSentence.displayFlg || state.questionNumAreas.compoundOpposite.displayFlg )
        && state.selectedSearchType === 2
    },


    // value
    selectedUnits: state => {
      return state.selectedQuestionRangeTangen
        .filter(unit => unit.gradeId == state.selectedGrade)
        .filter(unit => unit.publisherId == state.selectedTextbook)
        .map(parent => parent.children.length !== 0 ? parent.children : parent)
        .flat().filter(unit => unit?.checked || unit.isAllSelected)
    },
    selectedThemes: state => {
      return state.selectedQuestionRangeTheme
        .map(parent => parent.children)
        .flat().filter(child => child.checked)
    },
    wasInputTangoRangePages: state => {
      return state.selectedQuestionRangePage.tango.filter(page => {
        return !((page.start !== 0 && !page.start) || (!page.end))
      })
    },
    wasInputRengRangePages: state => {
      return state.selectedQuestionRangePage.rengo.filter(page => {
        return !((page.start !== 0 && !page.start) || (!page.end))
      })
    },
    wasInputTangoRangeMidashiIds: state => {
      return state.selectedQuestionRangeMidashi.tango.filter(range => {
        return !((range.start !== 0 && !range.start) || (!range.end))
      })
    },
    wasInputRengoRangeMidashiIds: state => {
      return state.selectedQuestionRangeMidashi.rengo.filter(range => {
        return !((range.start !== 0 && !range.start) || (!range.end))
      })
    },
    sendWordCountAttributes: state => {
      const paramsArray = Object.entries(state.questionNumAreas)
        .filter(([, attribute]) => attribute.displayFlg)
        .map(([key, attribute]) => [key, attribute.value])
      return Object.fromEntries(paramsArray)
    },
    // プリント名を取得（初期値：ログイン情報から教室名を取得）
    printTitle:(state, getters, rootState) => {
      return state.printTitle ? state.printTitle : rootState.user.classroomName
    },
    // 「問題作成API・出題可能数取得API」共通で使用するパラメータを作成する
    sendApiCommonParams: (state, getters) => {
      return {
        materialId: state.selectedSearchType,
        condition: getters.createParamModule.createApiConditionParam(state, getters)
      }
    },
    createParamModule: state => {
      if (state.selectedSearchType === 1) return publisher
      if (state.selectedSearchType === 2) return getThrough
      return null
    }
  },

  mutations: {
    initialize(state) {
      Object.assign(state, cloneDeep(initialState))
    },
    setFirstSelectedSearchType(state, payload) {
      state.firstSelectedSearchType = payload.boolean
    },
    //教科書・ゲットスルー
    setSelectedSearchType(state, payload) {
      state.selectedSearchType = payload.searchType;
      if(state.selectedCategory === 3) state.selectedCategory = ''; //問題種別が３：テーマの場合は空にする
      if(state.selectedSearchType === 1 && !state.checkedArr['target'].includes(1)) state.checkedArr['target'].push(1) //教科書の場合は出題対象に「単語」を追加する
      if (state.selectedSearchType === 2) {
        state.selectedQuestionRangeType = 3; //範囲種別は「見出しから選択」を初期値に設定する
      } else {
        state.selectedQuestionRangeType = 1; //範囲種別は「ページ範囲」を初期値に設定する
        state.selectedTextbook = 1
        state.selectedGrade = 1
      }
      state.questionNumAreasDisplayCheck()
    },
    //準拠
    setSelectedTextbook(state, payload) {
      state.selectedTextbook = payload.textBook;
    },
    //選択中の学年
    setSelectedGrade(state, payload) {
      state.selectedGrade = payload.grade;
    },
    //問題種別（1:見出し、2:応用、3:テーマ）
    setSelectedCategory(state, payload) {
      state.selectedCategory = payload.category;
      state.questionNumAreasDisplayCheck() //設問数設定エリアの表示制御
      // テーマ別が選ばれてたら、範囲を「ページから選択」を初期値, gradeとpublisherも変更
      if (state.selectedCategory === 3) {
        state.selectedQuestionRangeType = 1
        state.selectedTextbook = 7
        state.selectedGrade = 4
      } else if (state.selectedSearchType === 2){
        state.selectedQuestionRangeType = 3
      }
    },
    //チェックボックス群
    resetCheckListTarget(state) {
      state.checkedArr.target = []
    },
    setCheckList(state, payload) {
      payload.value.forEach(x=>{
        const targetIndex = state.checkedArr[payload.listName].indexOf(x)
        state.checkedArr[payload.listName].includes(x)
          ? state.checkedArr[payload.listName].splice(targetIndex, 1)     //含まれていたら削除
          : state.checkedArr[payload.listName].push(x)                    //含まれていなかったら追加
      })
      if(payload.value.length<=0) state.checkedArr[payload.listName] = [] //すべてを選択をoffにした場合
      state.questionNumAreasDisplayCheck()                                //設問数設定エリアの表示制御
    },
    //活用問題のすべてを選択フラグ
    setKatsuyoAllCheck(state, payload) {
      state.katsuyoAllCheck = payload.katsuyoAllCheck
    },
    //範囲種別（1:ページ、2:単元、3:見出し）
    setSelectedQuestionRangeType(state, payload) {
      state.selectedQuestionRangeType = payload.rangeType;
    },
    setMasterQuestionRangeTangen(state, payload) {
      //単元マスターをセット
      state.selectedQuestionRangeTangen = payload.allUnits
    },
    setMasterQuestionRangeTheme(state, payload) {
      //テーママスターをセット
      state.selectedQuestionRangeTheme = payload.allThemes
    },
    //範囲詳細(1:ページ)
    setSelectedQuestionRangePage(state, payload) {
      if(payload.type === 'start') state.selectedQuestionRangePage[payload.word][payload.index].start = payload.value
      else if(payload.type === 'end') state.selectedQuestionRangePage[payload.word][payload.index].end = payload.value
      else if(payload.type === 'delete') state.selectedQuestionRangePage[payload.word].splice(payload.index-1, 1)                                                    //入力欄 削除
      else if(payload.type === 'add')
        if(!state.selectedQuestionRangePage[payload.word][payload.index]) state.selectedQuestionRangePage[payload.word].splice(payload.index, 1, {start: '', end: ''}) //入力欄 追加
        else if(state.selectedQuestionRangePage[payload.word][payload.index]) state.selectedQuestionRangePage[payload.word].push({start: '', end: ''})                 //入力欄 追加
    },
    //範囲詳細(2:単元)
    setSelectedQuestionRangeTangen(state, payload) {
      const targetTangen = state.selectedQuestionRangeTangen.find(tangen => tangen.value === payload.value)
      Object.assign(targetTangen, payload.params)

      if(payload.mode == 'checkAll') {
        targetTangen.children.forEach(child => {
          if(payload.params.isAllSelected) child.checked = true //すべてにチェックする
          else child.checked = false                     //すべてチェック外す
        })
      }
      if(payload.childIndex != null) {
        //childにチェックする
        targetTangen.children[payload.childIndex].checked = payload.checked
      }
    },
    //範囲詳細(3:見出し)
    setSelectedQuestionRangeMidashi(state, payload) {
      if(payload.type === 'start') state.selectedQuestionRangeMidashi[payload.word][payload.index].start = payload.value
      else if(payload.type === 'end') state.selectedQuestionRangeMidashi[payload.word][payload.index].end = payload.value
      else if(payload.type === 'delete') state.selectedQuestionRangeMidashi[payload.word].splice(payload.index-1, 1)                                                       //入力欄 削除
      else if(payload.type === 'add')
        if(!state.selectedQuestionRangeMidashi[payload.word][payload.index]) state.selectedQuestionRangeMidashi[payload.word].splice(payload.index, 1, {start: '', end: ''}) //入力欄 追加
        else if(state.selectedQuestionRangeMidashi[payload.word][payload.index]) state.selectedQuestionRangeMidashi[payload.word].push({start: '', end: ''})                 //入力欄 追加
    },
    //テーマ範囲
    setSelectedQuestionRangeTheme(state, payload) {
      Object.assign(state.selectedQuestionRangeTheme[payload.index], payload.params)

      if(payload.mode == 'checkAll') {
        state.selectedQuestionRangeTheme[payload.index].children.forEach(child => {
          if(payload.params.isAllSelected) child.checked = true //すべてにチェックする
          else child.checked = false                     //すべてチェック外す
        })
      }
      if(payload.childIndex != null) {
        //childにチェックする
        state.selectedQuestionRangeTheme[payload.index].children[payload.childIndex].checked = payload.checked
      }
    },
    //範囲種別切り替え時に選択範囲をリセットする
    setResetRange(state, payload) {
      if(payload.rangeType==1) {
        //単元と見出しをリセット
        state.selectedQuestionRangeTangen.forEach(tangen=>{
          tangen.isAllSelected = false
          tangen.children.forEach(child => {
            child.checked = false
          })
        })
        state.selectedQuestionRangeMidashi = {
          tango: [ {start: '', end: ''} ],
          rengo: [ {start: '', end: ''} ],
        }
      } else if(payload.rangeType==2) {
        //ページと見出しをリセット
        state.selectedQuestionRangePage = {
          tango: [ {start: '', end: ''} ],
          rengo: [ {start: '', end: ''} ],
        }
        state.selectedQuestionRangeMidashi = {
          tango: [ {start: '', end: ''} ],
          rengo: [ {start: '', end: ''} ],
        }
      } else if(payload.rangeType==3) {
        //ページと単元をリセット
        state.selectedQuestionRangePage = {
          tango: [ {start: '', end: ''} ],
          rengo: [ {start: '', end: ''} ],
        }
        state.selectedQuestionRangeTangen.forEach(tangen=>{
          tangen.isAllSelected = false
          tangen.children.forEach(child => {
            child.checked = false
          })
        })
      }
    },
    //設問数
    setInputQuestionNum(state, payload) {
      state.questionNumAreas[payload.key].value = payload.value
    },
    //出題可能語数
    setMaxAvailableWordNum(state, payload) {
      state.questionNumAreas[payload.key].maxAvailableWordNum = payload.maxAvailableWordNum
    },
    //検索フラグ
    setSearchedFlg(state, payload) {
      state.searchedFlg = payload.searchedFlg
    },
    //指定範囲のすべてを出題するフラグ
    setAllCheckFlg(state, payload) {
      state.allCheckFlg = payload.allCheckFlg
      //値の反映
      Object.entries(state.questionNumAreas)
        .map(a => a[1])
        .forEach(area=>{
          if(state.allCheckFlg) area.value = area.maxAvailableWordNum
        })
    },
    //ソート
    setSelectedQuestionSortType(state, payload) {
      state.selectedQuestionSortType = payload.sortType;
    },
    //解説の有無
    setSelectedQuestionDescription(state, payload) {
      state.selectedQuestionDescription = payload.id;
    },
    //(保存問題表示用)
    setCheckedArr(state, payload) {
      state.checkedArr[payload.listName] = payload.value;
    },
    setSavePrintMode(state, payload) {
      state.savePrintMode = payload.savePrintMode;
    },
    setPrintTitle(state, payload) {
      state.printTitle = payload.printTitle
    },
    setPrintData(state, payload) {
      state.printData = payload.printData;
    },
    setConditionDetails(state, payload) {
      state.conditionDetails = payload.conditionDetails;
    },
    setSelectedLogoFlg(state, payload) {
      state.selectedLogoFlg = payload.logoFlg
    },
  },

  actions: {
    async searchCount({ state, commit, getters}){
      //出題可能語数取得APIを実行
      const params = getters.sendApiCommonParams
      const res = await axios.post('/api/v1/words/count', params)

      //出題可能語数合計を算出
      const totalCount = Object.entries(res.data)
        .reduce((sum, element) => { return sum + element[1]}, 0);

      //検索結果をset
      Object.entries(state.questionNumAreas)
        .forEach(([key, ]) => {
          commit('setMaxAvailableWordNum', {
            key: key,
            maxAvailableWordNum: res.data[key]
          })
        })

      if(totalCount === 0) return { status: 'error', message: '指定範囲内に出題可能語がありません' }

      return { status: 'success', message: ''}
    },
    async validate({state, getters}, mode) {
      try {
        //教科書・単語集の必須チェック
        if(!state.selectedSearchType)           throw '教科書・単語集を選択してください'

        // 教科書用のvalidation
        const result = getters.createParamModule.validate(state, getters, mode)
        if (result.status === 'error')          throw result.message

      } catch (e) {
        return { status: 'error', message: e }
      }
      return { status: 'success', message: '' }
    },

    // 問題作成API実行
    async questionCreate({state, commit, getters, rootState}, params) {
      try {
        //パラメータ追加
        const sendParams = {}

        Object.assign(sendParams, params)

        Object.assign(sendParams, {
          print: {
            materialId: state.selectedSearchType,         //教材ID
            name:       getters.printTitle,                  //プリント名
            logoFlag: rootState.user.hasLogo ? state.selectedLogoFlg === 1 : false,
          }
        })
        //保存API用に抽出条件詳細をstoreに保存(json形式)
        commit('setConditionDetails', {conditionDetails: JSON.stringify(sendParams) })

        //問題作成APIを実行する
        const res = await axios.post('/api/v1/prints/', sendParams)
        commit('setPrintData', {printData: res.data })

      } catch (e) {
        return { status: 'error', message: e }
      }
      return { status: 'success', message: '' }
    },

  },
}
